import React from 'react';
import config from '@config';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Button, Typography } from '@ui';
import { Flex } from 'antd';
import { StyledAlert } from './styled';

const NotConnected = ({ storeUrl }) => {
    return (
        <div style={BOTTOM_INDENTS.M}>
            <StyledAlert>
                <Flex justify='space-between' align='center'>
                    <Typography.Text
                        data-e2e='integrations_notconnected-status_block'
                        color={COLORS.$tartRed}
                        type='descriptor1'
                    >
                        Shopify App is not connected to Klickly.
                    </Typography.Text>
                    <Button
                        data-e2e='integrations_go-to-connector-app_btn'
                        style={{ width: 184 }}
                        block
                        type='primary'
                        onClick={() => {
                            window.open(
                                `https://${storeUrl}/admin/settings/apps/app_uninstallations/app/${config.shopifyAppName}`,
                                '_blank'
                            );
                        }}
                    >
                        Go to my Shopify store
                    </Button>
                </Flex>
            </StyledAlert>
        </div>
    );
};

export default NotConnected;
